export default __webpack_public_path__ + "static/media/marker-sky-red.ac8cbe3c.png";